import { useState } from "react";

import { Grid, Typography, Chip, Button } from "@mui/material";

import {
  DefaultSelectableChip,
  SearchActionInput,
} from "@aclymatepackages/atoms";
import { truncateText } from "@aclymatepackages/other-helpers";

import { fetchOurApi } from "../../../helpers/utils/apiCalls";

const OpenAiVendorCategorization = ({
  naicsCodes = [],
  editVendor,
  naicsCode,
  naicsTitle,
  disabled,
  overrideNaicsTitle,
  questionText = "What does this company do?",
}) => {
  const [naicsCodesOptionsLoading, setNaicsCodesOptionsLoading] =
    useState(false);
  const [naicsCodesOptions, setNaicsCodesOptions] = useState(naicsCodes);
  const [companyDescription, setCompanyDescription] = useState("");
  const [originalNaicsTitle, setOriginalNaicsTitle] = useState(naicsTitle);

  const onDescriptionNaicsFetch = async () => {
    setNaicsCodesOptionsLoading(true);
    await fetchOurApi({
      path: "/open-ai/fetch-naics-codes-from-description",
      data: { description: companyDescription, originalNaicsCode: naicsCode },
      method: "POST",
      callback: ({ naicsCodes }) => setNaicsCodesOptions(naicsCodes),
    });
    return setNaicsCodesOptionsLoading(false);
  };

  return (
    <>
      {!naicsCodesOptions.length &&
        !originalNaicsTitle &&
        !overrideNaicsTitle && (
          <Grid item>
            <SearchActionInput
              label={questionText}
              value={companyDescription}
              setValue={setCompanyDescription}
              searchLoading={naicsCodesOptionsLoading}
              searchFunction={onDescriptionNaicsFetch}
              disabled={disabled}
            />
          </Grid>
        )}
      {(originalNaicsTitle || overrideNaicsTitle) &&
        !naicsCodesOptions?.length && (
          <Grid item alignSelf="center">
            <Chip
              label={truncateText(overrideNaicsTitle || originalNaicsTitle, 50)}
              onDelete={!disabled && (() => setOriginalNaicsTitle(null))}
            />
          </Grid>
        )}
      {!!naicsCodesOptions?.length && (
        <Grid item container spacing={2} direction="container">
          <Grid item>
            <Typography variant="h6" align="center">
              Select the industry for this vendor
            </Typography>
          </Grid>
          <Grid item container justifyContent="center" spacing={2}>
            {naicsCodesOptions.map(
              ({ code, description, tonsCo2ePerDollar }, idx) => (
                <Grid item key={`naics-chip-${idx}`}>
                  <DefaultSelectableChip
                    label={truncateText(description, 50)}
                    onClick={(e) => {
                      e.stopPropagation();
                      editVendor("naicsTitle")(description);
                      editVendor("naicsCode")(code);
                      return editVendor("tonsCo2ePerDollar")(tonsCo2ePerDollar);
                    }}
                    isSelected={naicsCode === code}
                  />
                </Grid>
              )
            )}
          </Grid>
          <Grid item container justifyContent="center">
            <Grid item>
              <Button
                color="primary"
                onClick={(e) => {
                  e.stopPropagation();
                  setNaicsCodesOptions([]);
                  return setOriginalNaicsTitle(null);
                }}
                disabled={disabled}
              >
                Choose Different Categories
              </Button>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
};
export default OpenAiVendorCategorization;
